import { Close, Save } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputAdornment, MenuItem, Select } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton"
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";
import { postSubmit } from "global/postFunc";
import { useEffect, useState } from "react";
import { postDataWithResponse } from "global/postFunc";
import TambahKelompok from "./TambahKelompok";

const EditRincian = ({ open, parentData, decryptedUser, updating, setUpdating, addReq, handleCloseDialog }) => {
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [updatingKm, setUpdatingKm] = useState(false)

    const [rekeningAkun, setRekenigAkun] = useState({})
    const [sumberDana, setSumberaDana] = useState({})
    const [selectedKelPaket, setSelectedKelPaket] = useState({})
    const [komponen, setKomponen] = useState('')
    const [listKelPaket, setListKelPaket] = useState([])
    const [spesifikasi, setSpesifikasi] = useState('')
    const [koefisien, setKoefisien] = useState('')
    const [satuan, setSatuan] = useState('')
    const [volume, setVolume] = useState('')
    const [anggaran, setAnggaran] = useState('')

    useEffect(() => {
        if (open) {
            setRekenigAkun({
                kode: parentData.kode_rekening_akun,
                uraian: parentData.uraian_rekening_akun
            })
            setSumberaDana({
                kode: parentData.kode_sumber_dana,
                uraian: parentData.uraian_sumber_dana
            })
            setKomponen(parentData.nama_komponen)
            setSelectedKelPaket({
                id: parentData.kel_paket_id,
                uraian: parentData.kel_paket_uraian
            })
            setSpesifikasi(parentData.spesifikasi)
            setKoefisien(parentData.koefisien)
            setSatuan(parentData.satuan)
            setVolume(parentData.volume)
            setAnggaran(parentData.anggaran)
            console.log(parentData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    useEffect(() => {
        console.log(selectedKelPaket);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedKelPaket])

    useEffect(() => {
        // setSelectedKelPaket({})
        open && reqKelompokPaket()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, updating, updatingKm])

    const reqKelompokPaket = () => {
        setLoading(true)
        addReq()
        postDataWithResponse(
            // '/get-subrincianobjek-belanja-by-rincianobjek/' + params,
            '/admin-opd/kelompok-paket/filter',
            {
                ta: parentData.ta,
                kd_pd: parentData.kd_pd,
                kd_subkegiatan: parentData.kd_subkegiatan,
                kode_rekening_akun: parentData.kode_rekening_akun,
            },
            decryptedUser,
            (res) => {
                setLoading(false)
                setListKelPaket(res)
            },
            (res) => {
                setLoading(false)
                handleCloseDialog()
            }
        );
    }

    const submit = (e) => {
        e.preventDefault();
        setSaving(true)
        addReq()
        postSubmit(
            '/admin-opd/komponen-belanja/update/' + parentData.id,
            {
                // id_sub_rincian_objek: `${parentData.id}-${subRincianObjekBl.kd_sub_rincian_objek}`,
                _method: 'PUT',
                kel_paket_id: selectedKelPaket.id,
                kel_paket_uraian: selectedKelPaket.uraian,
                koefisien: koefisien,
                satuan: satuan,
                volume: volume,
                anggaran: anggaran.replace(/,(?=\d{3})/g, '')
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleCloseDialog()
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                // setOpen(false)
            }
        )
        // console.log('submit');
    }

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setAnggaran(addCommas(removeNonNumeric(event.target.value)))
    }

    const [openPengelompokan, setOpenPengelompokan] = useState(false);

    const handleClickOpenPengelompokan = () => {
        setOpenPengelompokan(true);
    };

    const handleClosePengelompokan = () => {
        setOpenPengelompokan(false);
    };

    return (
        <>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                // fullScreen
                scroll='paper'
                p={3}
                component='form'
                onSubmit={submit}
            >
                <DialogTitle>
                    <ArgonTypography variant='body2' fontWeight="bold">Edit Komponen Belanja</ArgonTypography>
                </DialogTitle>
                <DialogContent p={3}>
                    <ArgonBox mb={1}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Sub Kegiatan : {parentData.kd_subkegiatan} {parentData.nama_subkegiatan}
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Rekening Akun
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={rekeningAkun.kode + ' ' + rekeningAkun.uraian}
                            disabled
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Uraian Pengelompokan Belanja / Paket Pekerjaan
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                            <Select
                                placeholder="Select year"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedKelPaket.id || ''}
                                onChange={(e) => {
                                    let result = listKelPaket.find(item => item.id === e.target.value)
                                    setSelectedKelPaket(result)
                                }}
                                required
                                endAdornment={
                                    loading && <CircularProgress color="inherit" size={20} />
                                }
                            >
                                <MenuItem key='9999' value='' disabled><em>Pilih</em></MenuItem>
                                {
                                    listKelPaket.map((kelPaket, index) => (
                                        <MenuItem key={index} value={kelPaket.id}>{kelPaket.uraian}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <Button size="small" color="primary" disabled={!rekeningAkun.kode}  onClick={handleClickOpenPengelompokan} variant="text">Tambah Pengelompokan Belanja / Paket Pekerjaan</Button>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Sumber Pendanaan
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={sumberDana.kode + ' ' + sumberDana.uraian}
                            disabled
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Komponen
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={komponen}
                            disabled
                            onChange={(e) => { setKomponen(e.target.value) }}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Spesifikasi
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={spesifikasi}
                            disabled
                            onChange={(e) => { setSpesifikasi(e.target.value) }}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <Grid container spacing={2}>
                            <Grid item lg={6}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Koefisien
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    required
                                    size="medium"
                                    value={koefisien}
                                    onChange={(e) => setKoefisien(e.target.value)}
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item lg={6}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Satuan
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    required
                                    size="medium"
                                    value={satuan}
                                    onChange={(e) => setSatuan(e.target.value)}
                                    autoComplete='off'
                                />
                            </Grid>
                        </Grid>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Volume
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="number"
                            required
                            size="medium"
                            value={volume}
                            onChange={(e) => { setVolume(e.target.value) }}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Anggaran
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={anggaran}
                            onChange={handleAnggaranChange}
                            autoComplete='off'
                            startAdornment={
                                <InputAdornment position="start">
                                    <ArgonTypography component="label" variant="caption" >
                                        Rp
                                    </ArgonTypography>
                                </InputAdornment>
                            }
                        />
                    </ArgonBox>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                        <Grid item>
                            <ArgonButton
                                color='info'
                                variant='outlined'
                                size="small"
                                startIcon={<Close />}
                                onClick={handleCloseDialog}
                            >
                                Batal
                            </ArgonButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton
                                color='info'
                                variant='contained'
                                size="small"
                                startIcon={<Save />}
                                type='submit'
                                loading={saving}
                            >
                                Simpan
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <TambahKelompok
                open={openPengelompokan}
                handleClose={handleClosePengelompokan}
                // metodePengadaan={metodePengadaan}
                parentData={rekeningAkun}
                decryptedUser={decryptedUser}
                ta={parentData.ta}
                kd_pd={parentData.kd_pd}
                kd_subkegiatan={parentData.kd_subkegiatan}
                updating={updatingKm}
                setUpdating={setUpdatingKm}
            />
        </>
    )
}

export default EditRincian